import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const listPayTargets = (searchKey = '') => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.PAY_TARGETS_LIST_LOADING,
  });
  return fetch
    .post('enverus/appTargets', {
      input: {
        searchKey,
      },
    })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_LIST_SUCCESS,
        payload: {
          data,
          paginatedElements: data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.PAY_TARGETS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
